import React, { useState } from 'react';
import { X, Mail, Lock, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose }) => {
  const [isSignup, setIsSignup] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, signup } = useAuth();

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      let result;
      if (isSignup) {
        result = await signup(formData.email, formData.password, formData.name);
      } else {
        result = await login(formData.email, formData.password);
      }

      if (result.success) {
        onClose();
        // Redirect to calendar
        window.location.href = '/calendar';
      } else {
        setError(result.error || 'Authentication failed');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        <button className="login-modal-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="login-modal-content">
          <h2>{isSignup ? 'Join B2P' : 'Welcome Back'}</h2>
          <p className="login-modal-subtitle">
            {isSignup 
              ? 'Create an account to access the event calendar and purchase tickets'
              : 'Login to access the event calendar and purchase tickets'
            }
          </p>

          {error && (
            <div className="login-modal-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            {isSignup && (
              <div className="login-form-group">
                <label htmlFor="name">
                  <User size={20} />
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your name"
                />
              </div>
            )}

            <div className="login-form-group">
              <label htmlFor="email">
                <Mail size={20} />
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your@email.com"
              />
            </div>

            <div className="login-form-group">
              <label htmlFor="password">
                <Lock size={20} />
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="••••••••"
                minLength="6"
              />
            </div>

            <button 
              type="submit" 
              className="btn login-submit-btn"
              disabled={loading}
            >
              {loading ? 'Please wait...' : (isSignup ? 'Sign Up' : 'Login')}
            </button>
          </form>

          <div className="login-modal-toggle">
            {isSignup ? (
              <>
                Already have an account?{' '}
                <button onClick={() => setIsSignup(false)}>
                  Login
                </button>
              </>
            ) : (
              <>
                Don't have an account?{' '}
                <button onClick={() => setIsSignup(true)}>
                  Sign Up
                </button>
              </>
            )}
          </div>

          <div className="login-modal-info">
            <p>
              By creating an account, you'll get access to:
            </p>
            <ul>
              <li>📅 Event calendar with all upcoming parties</li>
              <li>🎫 Easy ticket purchasing</li>
              <li>📍 Location reveals upon RSVP</li>
              <li>💌 Priority notifications for new events</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;


